import { render, staticRenderFns } from "./ContactListsTab.vue?vue&type=template&id=3fd4f74f&"
import script from "./ContactListsTab.vue?vue&type=script&lang=js&"
export * from "./ContactListsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports